import messages from './messages';

export const LESSON_PLUGIN = {
  PLUGIN_ID: 'd543f040-5f60-11ea-be6d-97aa63e758bc',
  INFO: 'Summary',
  PATHWAY: [{ key: ['pathway'], value: 'FREE' }],
};

export const SCREEN_PLUGIN = {
  PLUGIN_ID: '9417ac60-5f60-11ea-8e69-affb2224d7e8',
  INFO: 'Summary',
  INFO_CASE_STUDY: 'Case study',
  INFO_FEATURE_BOX: 'Local Lens Feature Box',
  INFO_TRANSLATION: 'Translation',
};

export const COMPONENT_NAME = {
  AI_EDIT_PROMPT: 'AIEditPrompt',
};

export const NO_CHOICES_SELECTED = 'No choices selected.';
export const NO_INPUT_DATA = 'No input data.';

// REQ (Request) represents the action type being requested
// RES (Response) represents the message that should be displayed for the action
export const ACTION_MESSAGES = {
  REQ_CHOICE_SELECTION: 'ChoiceSelection',
  RES_CHOICE_SELECTION: 'You have selected :',
  REQ_VIEW_PROMPTS: 'ViewPrompts',
  RES_VIEW_PROMPT: 'View Prompt',
  REQ_PROMPTS: 'Prompts',
  REQ_GENERATE_SUMMARY: 'GenerateSummary',
  RES_GENERATE_SUMMARY: 'Generate Summary',
  REQ_RES_RETRY: 'Retry',
  REQ_EDIT_PROMPT: 'EditPrompt',
  RES_EDIT_PROMPT: 'Edit Prompt',
  REQ_RES_CONTINUE: 'Continue',
  REQ_RES_GENERATE: 'Generate',
  REQ_SUMMARY_MESSAGE: 'SummaryMessage',
  RES_SUMMARY_MESSAGE: 'Here’s the summary, based on your preferences. Please review it, insert it or retry.',
  REQ_CREATED_SUMMARY: 'CreatedSummary',
  REQ_RES_INSERT: 'Insert',
  RES_UNKNOWN_ACTION: 'Unknown Action',
  REQ_INSERTED: 'Inserted',
  RES_INSERTED: 'Summary inserted at the end of',
  REQ_MODELCHANGE: 'ModelChange',
  RES_MODELCHANGE: 'exceeds the volume that',
  RES_MODELTEXT: 'can handle to generate a summary. I have switched to',
  RES_MODELTEXT_CONTENT: 'to generate your summary instead.',
  RES_MODAL_CHANGE: _getModalChangeMessage,
  REQ_FIELD_INPUTS: 'FilledInputs',
  RES_FIELD_INPUTS: 'You filled in ',
  REQ_CASE_STUDY_MESSAGE: 'CaseStudyMessage',
  RES_CASE_STUDY_MESSAGE: 'Here’s the Case study, based on your preferences. Please review it, insert it or retry.',
  REQ_CREATED_CASE_STUDY: 'CreatedCaseStudy',
  REQ_GENERATE_CASE_STUDY: 'GenerateCaseStudy',
  RES_GENERATE_CASE_STUDY: 'Generate Case study',
  REQ_CASE_STUDY_INSERTED: 'Case study Inserted',
  RES_CASE_STUDY_INSERTED: 'Case study inserted at the end of',
  REQ_FEATURE_BOX_MESSAGE: 'FeatureBoxMessage',
  RES_FEATURE_BOX_MESSAGE: "Here's the Feature Box, based on your preferences. Please review it, insert it or retry.",
  REQ_CREATED_FEATURE_BOX: 'CreatedFeatureBox',
  REQ_GENERATE_FEATURE_BOX: 'GenerateFeatureBox',
  RES_GENERATE_FEATURE_BOX: 'Generate Feature Box',
  REQ_FEATURE_BOX_INSERTED: 'Feature Box Inserted',
  RES_FEATURE_BOX_INSERTED: 'Feature Box inserted at the end of',
  REQ_TRANSLATE_MESSAGE: 'TranslateMessage',
  RES_TRANSLATE_MESSAGE: "Here's the translation, based on your preferences. Please review it.",
  REQ_CREATED_TRANSLATION: 'CreatedTranslation',
  REQ_GENERATE_TRANSLATION: 'GenerateTranslation',
  RES_GENERATE_TRANSLATION: 'Generate Translation',
  RES_TRANSLATION_INSERTED: 'Translation inserted',
};

export const USER_TYPE = {
  BOT: 'bot',
  USER: 'user',
  INCOMING: 'incoming',
};

export const PAICE_RESPONSE = {
  COMPLETED: 'COMPLETED',
  IN_PROGRESS: 'IN PROGRESS',
  QUEUED: 'QUEUED',
};

export const AI_SUMMARY_ACTIONS = {
  CREATE_TASK: 'createTask',
  SUMMARY: 'summary',
  HISTORY: 'history',
  CASE_STUDY: 'case-study',
  FEATURE_BOX: 'feature-box',
  TRANSLATE_TEXT: 'translate',
};

export const actionType = Object.freeze({
  GENERATE_CASE_STUDY: 'GENERATE_CASE_STUDY',
  GENERATE_FEATURE_BOX: 'GENERATE_FEATURE_BOX',
  TRANSLATE_TEXT: 'TRANSLATE_TEXT',
  GENERATE_SUMMARY: 'GENERATE_SUMMARY',
  GENERATE_HISTORY: 'GENERATE_HISTORY',
});

export const actionSteps = Object.freeze({
  GENERATE_CASE_STUDY: 5,
  GENERATE_FEATURE_BOX: 6,
  TRANSLATE_TEXT: 7,
  GENERATE_SUMMARY: 0,
});

export const svgIconType = Object.freeze({
  GENERATE_CASE_STUDY: 'manage_search',
  GENERATE_FEATURE_BOX: 'grid_view',
  TRANSLATE_TEXT: 'translate',
  GENERATE_SUMMARY: 'short_text',
});


function _getModalChangeMessage(globalState){
  if (!globalState?.chapterName || !globalState?.model || !globalState?.aiModel) return "";
  return `<b>${globalState.chapterName}</b> ${ACTION_MESSAGES.RES_MODELCHANGE} <b>${globalState.model}</b> ${ACTION_MESSAGES.RES_MODELTEXT} <b>${globalState.aiModel}</b> ${ACTION_MESSAGES.RES_MODELTEXT_CONTENT}`;
}

export const actionsList = [
  {
    type: actionType.GENERATE_CASE_STUDY,
    icon: svgIconType.GENERATE_CASE_STUDY,
    message: messages.caseStudy,
    stepIndex: actionSteps.GENERATE_CASE_STUDY,
  },
  {
    type: actionType.TRANSLATE_TEXT,
    icon: svgIconType.TRANSLATE_TEXT,
    message: messages.translateText,
    stepIndex: actionSteps.TRANSLATE_TEXT,
  },
  {
    type: actionType.GENERATE_FEATURE_BOX,
    icon: svgIconType.GENERATE_FEATURE_BOX,
    message: messages.generateFeatureBox,
    stepIndex: actionSteps.GENERATE_FEATURE_BOX,
  },
  {
    type: actionType.GENERATE_SUMMARY,
    icon: svgIconType.GENERATE_SUMMARY,
    message: messages.generateSummary,
    stepIndex: actionSteps.GENERATE_SUMMARY,
  },
];

export const AI_LABEL_CLASS = "ai-label";


export const INSERT_MENU_OPTIONS = [
  { label: 'New screen', value: 'new' },
  { label: 'Same screen', value: 'same' },
];

export const CASE_STUDY_TAGNAME = 'Case study';
export const FEATURE_BOX_TAGNAME = 'Local Lens Feature Box';
export const INSERT_MENU_NEW = 'new';
export const INSERT_MENU_SAME = 'same';

export const CASE_STUDY_ERROR_TOAST_ID = 'case-study-error-toast';
export const FEATURE_BOX_ERROR_TOAST_ID = 'feature-box-error-toast';
export const SUMMARY_ERROR_TOAST_ID = 'summary-error-toast';
export const TRANSLATION_ERROR_TOAST_ID = 'translation-error-toast';

export const CASE_STUDY_SUBSCRIPTION_ERROR_MESSAGE = 'Failed to receive case study results. Please try again.';
export const CASE_STUDY_GENERATION_ERROR_MESSAGE = 'Failed to generate case study. Please try again.';
export const CASE_STUDY_SUBSCRIPTION_SETUP_ERROR_MESSAGE = 'Failed to set up case study subscription. Please try again.';
export const CASE_STUDY_UNEXPECTED_ERROR_MESSAGE = 'An unexpected error occurred while generating case study.';

export const FEATURE_BOX_SUBSCRIPTION_ERROR_MESSAGE = 'Failed to receive "Local Lens" feature results. Please try again.';
export const FEATURE_BOX_GENERATION_ERROR_MESSAGE = 'Failed to generate "Local Lens" feature results". Please try again.';
export const FEATURE_BOX_SUBSCRIPTION_SETUP_ERROR_MESSAGE = 'Failed to set up "Local Lens" feature subscription. Please try again.';
export const FEATURE_BOX_UNEXPECTED_ERROR_MESSAGE = 'An unexpected error occurred while generating the "Local Lens" feature.';

export const SUMMARY_FETCH_ERROR_MESSAGE = 'Failed to fetch summary. Please try again.';
export const SUMMARY_FETCH_ERROR_OCCURRED_MESSAGE = 'An error occurred while fetching summary.';
export const SUMMARY_UNEXPECTED_ERROR_MESSAGE = 'An unexpected error occurred while generating summary.';
export const SUMMARY_CREATE_TASK_ERROR_MESSAGE = 'Failed to create summary task. Please try again.';
export const SUMMARY_TASK_ID_SUBSCRIPTION_ERROR_MESSAGE = 'Failed to receive summary task ID. Please try again.';
export const SUMMARY_SUBSCRIPTION_SETUP_ERROR_MESSAGE = 'Failed to set up summary subscription. Please try again.';

export const TRANSLATION_SUBSCRIPTION_ERROR_MESSAGE = 'Failed to receive translation results. Please try again.';
export const TRANSLATION_SUBSCRIPTION_SETUP_ERROR_MESSAGE = 'Failed to set up translation subscription. Please try again.';
export const TRANSLATION_CONTENT_ERROR_MESSAGE = 'Failed to translate content. Please try again.';
export const TRANSLATION_UNEXPECTED_ERROR_MESSAGE = 'An unexpected error occurred during translation.';

export const UNKNOWN_ERROR_CODE = 'UNKNOWN_ERROR';

export const AI_SUBSCRIPTION_ERROR_TYPE = 'subscription_error';
export const AI_SUBSCRIPTION_SETUP_ERROR_TYPE = 'subscription_setup_error';
export const AI_EXCEPTION_ERROR_TYPE = 'exception';